"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#FCFEEF",
  z100: "#F4FECD",
  z200: "#E4F6A6",
  z300: "#D2EF7F",
  z400: "#BBD959",
  z500: "#A0BF3A",
  z600: "#85A437",
  z700: "#63842E",
  z800: "#486827",
  z900: "#304B01"
};
exports["default"] = _default;